import Vue from 'vue';
import App from '@/App.vue'
import './registerServiceWorker'

import VueHead from 'vue-head'
import NProgress from 'nprogress'
import axios from '@/helpers/http'
import plyr from 'plyr'
import atrament from 'atrament'
import { Base64 } from 'js-base64';

import store from './store'
import router from './router'
import base from '@/mixins/base'

Vue.use(VueHead, {
  seperator: "|",
  complement: "Online Sınav"
})

Vue.prototype.$axios = axios;
Vue.prototype.$nprogress = NProgress;
Vue.prototype.$plyr = plyr;
Vue.prototype.$atrament = atrament;
Vue.prototype.$base64 = Base64;

Vue.config.productionTip = false

new Vue({
  mixins: [base],
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const isLocal = document.location.hostname === 'localhost';

if (isLocal) {
  // window['ga-disable-UA-150272149-13'] = true;
} else {
  /*
  var element = new Image;
  var devtoolsOpen = false;
  element.__defineGetter__("id", function () {
    devtoolsOpen = true; // This only executes when devtools is open.
  });
  let tryCount = 0
  let paused = false
  setInterval(function () {
    devtoolsOpen = false;
    console.log(element);
    if (devtoolsOpen && !paused) {
      tryCount = tryCount + 1
      let message;
      switch (tryCount) {
        case 2:
          message = "Tarayıcı konsolunu henüz kapatmadığını fark ediyoruz. Lütfen kapatır mısın?"
          break;

        case 3:
          message = "Uyarılara rağmen denemeye devam ettin. Bu şekilde anlaşamayacağız. Yönlendiriliyorsun..."
          break;

        default:
          message = "Tarayıcı konsoluna erişiminiz engellenmiştir, lütfen bu işlemi tekrarlamayın! Birazdan bilgi merkezine yönlendirileceksiniz..."
          break;
      }
      paused = true
      var r = confirm(message)
      if (r == true) {
        location.href = "http://bilgimerkezi.bilfen.com/giris"
      } else {
        alert("O halde gereksiz denemeler yapmamalısın, senin için mühim olan bu web uygulamayı doğru bir şekilde kullanmandır. ");
      }
      paused = false
    }
  }, 1000);
  */
  document.oncontextmenu = function (e) { // eslint-disable-line
    return false
  }

  document.onkeydown = function (e) {
    if (window.event.keyCode == 123 || e.button == 2)
      return false;
  }
}